import { render, staticRenderFns } from "./Feladat.vue?vue&type=template&id=2baf56b6&"
import script from "./Feladat.vue?vue&type=script&lang=js&"
export * from "./Feladat.vue?vue&type=script&lang=js&"
import style0 from "./Feladat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports